// @flow

import React, {Children, cloneElement} from 'react';
import {convertPxToRem} from '@pb/kit-util-convert-px-to-rem';
import {Row} from './row.component';

type GetRowData = ({ children: React$Node, height?: number }) =>
    { children: React$Node, wrappedCells: React$Element<typeof Row> | null };

export const getRowData: GetRowData = props => {
    const cellItems = [];
    const children = Children.map(props.children, (child, key) => {
        if (!child) {
            return null;
        }
        if (child.type === Row) {
            return cloneElement(child, {
                th: true
            });
        }
        cellItems.push(cloneElement(child, {
            key,
            height: convertPxToRem(props.height)
        }));
        return null;
    });

    const wrappedCells = cellItems.length ? (
        <Row th={true}>
            {cellItems}
        </Row>
      ) : null;

    return {children, wrappedCells};
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./row.component");
